import "aos/dist/aos.css";

import { message, notification } from "antd";
import AOS from "aos";
import { useEffect, useState } from "react";

import { Loading, NoInternet } from "../_lib/_components";
import { loadUser, useAppSelector } from "../_lib/_store";
import Routers from "./Routes";

const App = () => {
  const [messageApi] = message.useMessage();
  const [_, contextHolder] = notification.useNotification();
  const { isLoading } = useAppSelector((state) => state.auth);
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const token = localStorage.getItem("token");
    token && loadUser();
  }, []);

  useEffect(() => {
    AOS.init();

    const handleOnlineStatusChange = () => {
      setOnline(navigator.onLine);
      if (!navigator.onLine) {
        messageApi.error("Check your internet connection");
      }
    };

    window.addEventListener("online", handleOnlineStatusChange);
    window.addEventListener("offline", handleOnlineStatusChange);

    return () => {
      window.removeEventListener("online", handleOnlineStatusChange);
      window.removeEventListener("offline", handleOnlineStatusChange);
    };
  }, []);

  if (isLoading) return <Loading />;

  return (
    <>
      {contextHolder}
      {online ? <Routers /> : <NoInternet />}
    </>
  );
};

export default App;
